import * as tslib_1 from "tslib";
import { constant, mapValues, camelCase, values } from 'lodash';
import { library, config } from '@fortawesome/fontawesome-svg-core';
import { createIcon } from './createIcon';
import { FontAwesomeIcon, FontAwesomeLayers, FontAwesomeLayersText } from './fontAwesomeWrapper';
export { createIcon };
export default (function (Vue, _a) {
    var e_1, _b;
    var icons = _a.icons, vuetifyIcons = _a.vuetifyIcons;
    library.add.apply(library, tslib_1.__spread(values(icons)));
    library.add.apply(library, tslib_1.__spread(values(vuetifyIcons)));
    config.autoAddCss = false;
    var vuetifiedIcons = mapValues(vuetifyIcons, createIcon);
    var iconDescriptors = mapValues(icons, function (value) { return ({
        configurable: false,
        enumerable: true,
        get: constant(createIcon(value)),
    }); });
    try {
        for (var _c = tslib_1.__values(values(vuetifyIcons)), _d = _c.next(); !_d.done; _d = _c.next()) {
            var value = _d.value;
            iconDescriptors[camelCase("fa-" + value.iconName)] = {
                configurable: false,
                enumerable: true,
                get: constant(createIcon(value)),
            };
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (_d && !_d.done && (_b = _c.return)) _b.call(_c);
        }
        finally { if (e_1) throw e_1.error; }
    }
    Vue.mixin({
        components: {
            FontAwesomeIcon: FontAwesomeIcon,
            FaIcon: FontAwesomeIcon,
            FontAwesomeLayers: FontAwesomeLayers,
            FaLayers: FontAwesomeLayers,
            FontAwesomeLayersText: FontAwesomeLayersText,
            FaLayersText: FontAwesomeLayersText,
            FaText: FontAwesomeLayersText,
        },
        beforeCreate: function () {
            if (!this.$options.inject)
                this.$options.inject = {};
            if (Array.isArray(this.$options.inject))
                return;
            var def = this.$options.icons
                ? mapValues(this.$options.icons, createIcon)
                : {};
            Object.defineProperties(def, iconDescriptors);
            this.$options.inject.$icons = { default: def };
        },
    });
    return vuetifiedIcons;
});
//# sourceMappingURL=plugin.js.map